<template>
  <v-dialog v-model="dialogOpen" width="500" @click:outside="close">
    <v-card>
      <v-card-title>Are you sure?</v-card-title>

      <v-card-text>
        Are you sure you want to add a bundle <b>{{productKind}}</b> product?
      </v-card-text>

      <v-divider></v-divider>
      
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" small @click="submit" :loading="getIsCreateLinkedProductLoading" :disabled="getIsCreateLinkedProductLoading">CONFIRM</v-btn>
        <v-btn color="primary" small outlined @click="close">CANCEL</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapState, mapActions, mapGetters } from 'vuex';

  export default {
    props: ['dialogOpen'],

    computed: {
      ...mapState('leads', ['currentLead']),
      ...mapGetters('productLinks', ['getLinkedProductId', 'getIsCreateLinkedProductLoading', 'getIsCreateLinkedProductError', 'getLinkedProductByType']),

      productKind() {
        let kind = this.currentLead.kind;
        return (kind==='VOIP')?'Broadband':'VoIP';
      },

      getLinkedTypeProduct() {
        return this.getLinkedProductByType("BUNDLE");
      },
    },

    methods: {
      ...mapActions('leads', ['getLeadProductByID', 'getLeadLinkedProductByID']),
      ...mapActions('productLinks', ['createLinkedProduct','fetchLinkedProduct']),

      async submit() {
        await this.createLinkedProduct({ lead_id: this.currentLead.id, payload: { link_type: "BUNDLE" } });
        if(!this.getIsCreateLinkedProductError){
          this.close();
          await this.getLeadProductByID({ id:this.currentLead.id });
          await this.getLeadLinkedProductByID(this.getLinkedProductId(this.currentLead.id).lead);
        }
      },

      close() {
        this.$emit('close-dialog');
      },
    },
  }
</script>

<style lang="scss" scoped></style>
